import { CommonModule } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit, computed, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getPlanesData, getVehicleData } from '../../helpers/dataLayerHelpers';
import { getSessionId } from '../../helpers/storageUtils';
import { Cotizacion } from '../../Models/cotizacion';
import { CrearCotizacion } from '../../Models/crearCotizacion';
import { DatosGenerales } from '../../Models/datosGenerales';
import { DatosPlanes } from '../../Models/datosPlanes';
import { PipesModule } from '../../pipes/pipes.module';
import { CotizacionService } from '../../services/Cotizacion/cotizacion.service';
import { DataLayerService } from '../../services/DataLayer/data-layer.service';
import { LeadsService } from '../../services/Leads/leads.service';
import { TiempoInactivoService } from '../../services/TiempoInactivo/tiempo-inactivo.service';
import { ApPromoCardComponent } from '../../shared/components/ap-promo-card/ap-promo-card.component';
import { PaymentAccordionComponent } from '../../shared/components/payment-accordion/payment-accordion.component';
import { AccordionItem } from '../../shared/interfaces/payment-accordion.types';
import { selectCotizacion } from '../../storage/Cotizacion/cotizacion.selectors';
import { selectData } from '../../storage/Lead/data.selectors';
import { selectPlanes } from '../../storage/Planes/planes.selector';
import { BannerAppComponent } from '../banner-app/banner-app.component';
import { FooterAppComponent } from '../footer-app/footer-app.component';

@Component({
  selector: 'app-pago-aprobado',
  standalone: true,
  imports: [
    BannerAppComponent,
    FooterAppComponent,
    PipesModule,
    CommonModule,
    PaymentAccordionComponent,
    ApPromoCardComponent,
  ],
  templateUrl: './pago-aprobado.component.html',
  styleUrl: './pago-aprobado.component.scss',
})
export class PagoAprobadoComponent implements OnInit {
  VariableSantiago = 'Santiago Salamanca';
  public planes!: Cotizacion;
  public planesTemp: Cotizacion | undefined;
  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;

  datosPlanes: DatosPlanes | null = null;
  datosPlanes$: Observable<DatosPlanes | null>;

  datosCotizacion: CrearCotizacion | null = null;
  datosCotizacion$: Observable<CrearCotizacion | null>;

  sessionId = '';
  public fecha = '';
  date: Date = new Date();

  tipoPago: string | undefined;
  PagoPlan: any;
  valorAntesE = 0;
  valorAntesT = 0;
  valorAntesP = 0;

  valorAPagar = 0;
  valorSubTotal = 0;
  valorMes = 0;

  paymentItems = signal<AccordionItem[]>([]);

  errorItems = signal<AccordionItem[]>([
    { label: 'Código:', value: '51' },
    { label: 'Descripción:', value: 'Fondos insuficientes' },
  ]);

  // Propiedad computed que genera el HTML dinámico con los valores reales
  insuranceSummaryDescription = computed(() => {
    const selectedPlan = this.planes?.data?.plan?.selected || '';
    const sumInsured = this.planes?.data?.plan?.sumInsured?.amount ?? 0;
    const vehicleRef = `${this.planes?.data?.asset?.brand} ${this.planes?.data?.asset?.cylinder}CC - ${this.planes?.data?.asset?.model}`;
    return `<p>${selectedPlan}</p> <p>Moto: ${vehicleRef}</p> <p class="text-bold">Valor asegurado: ${this.formatCurrency(sumInsured)}</p>`;
  });

  onToggle(open: boolean): void {
    console.log('Accordion:', open ? 'abierto' : 'cerrado');
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(LOCALE_ID) public locale: string,
    private store: Store,
    private leadServices: LeadsService,
    private tiempoInactivo: TiempoInactivoService,
    private cotizacion: CotizacionService,
    private dataLayerService: DataLayerService,
  ) {
    console.log('pago aprobado');
    this.datosGenerales$ = this.store.select(selectData);
    this.datosPlanes$ = this.store.select(selectPlanes);
    this.datosCotizacion$ = this.store.select(selectCotizacion);
  }
  async ngOnInit() {
    this.fecha = `${this.date.getFullYear()}-${this.date.getMonth() + 1}-${
      this.date.getDate() + 1
    }`;
    this.sessionId = getSessionId().toString();

    // Las suscripciones al store emiten síncronamente con el estado actual
    this.datosGenerales$.subscribe((data) => { this.datosGenerales = data; });
    this.datosPlanes$.subscribe((data) => { this.datosPlanes = data; });
    this.datosCotizacion$.subscribe((data) => { this.datosCotizacion = data; });

    // Misma pestaña: el store tiene datos reales del flujo (no el estado inicial vacío)
    if (this.datosGenerales?.Lead?.plate || this.datosPlanes?.selected_plan) {
      this.pushDataLayer('Pageview');
    }

    this.getParamPrepolicyId();


    this.tipoPago = this.datosPlanes?.payment_frequency;

    if (this.datosPlanes?.selected_plan === 'MOTOS_PlanEsencial') {
      const valorE = this.PagoPlan.priceMensual.amount * 0.2;
      this.valorAntesE = this.PagoPlan.priceMensual.amount + valorE;
      this.valorSubTotal = this.valorAntesE;
    }

    if (this.datosPlanes?.selected_plan === 'MOTOS_PlanTotal') {
      const valorT = this.PagoPlan.priceMensual.amount * 0.2;
      this.valorAntesT = this.PagoPlan.priceMensual.amount + valorT;
      this.valorSubTotal = this.valorAntesT;
    }

    if (this.datosPlanes?.selected_plan === 'MOTOS_PlanPremium') {
      const valorP = this.PagoPlan.priceMensual.amount * 0.2;
      this.valorAntesP = this.PagoPlan.priceMensual.amount + valorP;
      this.valorSubTotal = this.valorAntesP;
    }

    this.valorMes = this.PagoPlan.priceMensual.amount;
    this.valorAPagar =
      this.tipoPago === 'Monthly'
        ? this.PagoPlan.priceMensual.amount
        : this.PagoPlan.priceAnual.amount;
  }

  private getParamPrepolicyId(): void {
    this.route.queryParams.subscribe((params) => {
      const prepolicyid = params['prepolicyid'];
      if (prepolicyid) {
        this.cotizacion.getCotizacion(this.sessionId, prepolicyid).subscribe(
          (data) => {
            this.planes = data;

            // Pestaña nueva: store sin datos reales → disparar taggeo con datos de la API
            if (!this.datosGenerales?.Lead?.plate && !this.datosPlanes?.selected_plan) {
              this.pushDataLayer('Pageview');
            }

            this.paymentItems.set([
              { label: 'Estado:', value: 'Aprobado' },
              { label: 'Valor:', value: this.planes?.data?.plan?.sumInsured?.amount || 0 },
              { label: 'Código de respuesta:', value: this.planes?.data?.quote_id || 0 },
              { label: 'Referencia de pago:', value: this.planes?.data?.pre_policy_number || 'NA' },
              { label: 'Forma de pago:', value: 'NA' },
            ]);
          },
          (error) => {
            console.log('error en PagoAprovado:', error);
          },
        );
      }
    });
  }

  /**
   * Formatea un número como moneda con el locale del componente
   * @param value número a formatear
   * @returns string formateado como moneda
   */
  formatCurrency(value: number): string {
    return new Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  entendido() {
    this.pushDataLayer('Button', 'Entendido');
    window.location.href = 'https://www.sura.co/';
  }

  pushDataLayer(ecom_item: 'Pageview' | 'Button' | undefined, ecom_subitem = ''): void {
    if (this.planes?.data) {
      const asset = this.planes.data.asset;
      const plan = this.planes.data.plan;
      const rawSelected = plan.selected as any;
      const plan_seleccionado =
        typeof rawSelected === 'string'
          ? rawSelected
          : rawSelected?.Selected || rawSelected?.selected || '';
      const valor_plan =
        plan.paymentFrecuency === 'Monthly'
          ? plan.price?.price_monthly?.amount
          : plan.price?.full?.amount;

      this.dataLayerService.pushDataLayer({
        event: 'moto_ecommerce_step_6_pago_aprobado',
        ecom_tipo: 'Moto',
        ecom_item,
        ecom_subitem,
        ecom_pantalla: 'Pago aprobado',
        zona_circulacion: plan.zonaCirculacion || '',
        uso_vehiculo: 'Particular',
        placa: asset.plate || '',
        marca_vehiculo: asset.brand || '',
        modelo_vehiculo: asset.model || '',
        cilindraje_vehiculo: asset.cylinder || '',
        plan_seleccionado,
        periodicidad_pago: plan.paymentFrecuency || '',
        valor_plan,
        user_id: this.sessionId,
        dueño_paga_seguro: this.datosCotizacion?.dueño_paga_seguro || 'Si',
      });
    } else {
      this.dataLayerService.pushDataLayer({
        event: 'moto_ecommerce_step_6_pago_aprobado',
        ecom_tipo: 'Moto',
        ecom_item,
        ecom_subitem,
        ecom_pantalla: 'Pago aprobado',
        user_id: this.sessionId,
        ...getVehicleData(this.datosGenerales),
        ...getPlanesData(this.datosPlanes),
        dueño_paga_seguro: this.datosCotizacion?.dueño_paga_seguro || 'Si',
      });
    }
  }
}
